/**
 * Строки интерфейса живут в `shared/i18n.ts` — их читают обе платформы и
 * выгрузка на вычитку. Здесь только реэкспорт, чтобы импорты внутри web
 * остались короткими, и одна веб-только функция.
 */
export * from '../../shared/i18n.ts'

import type { Lang } from './data/cards'
import { makeT } from '../../shared/i18n.ts'

/**
 * Ставит язык документа. Влияет не на переводы, а на регистр: в азербайджанском
 * и турецком `i` переходит в `İ`, а не в `I`, и `text-transform: uppercase`
 * берёт правила именно из атрибута `lang`. При `lang="ru"` подпись `Bəli`
 * превращалась в `BƏLI` вместо `BƏLİ` — проверено в браузере.
 *
 * Отдельной функцией, а не строкой на месте, потому что **язык живёт в двух
 * местах**: в сторе у вошедшего человека и в собственном состоянии экрана входа
 * (`Login` рендерится вне `SirrProvider`, у него свой переключатель). Правка
 * одного места закрывала бы половину случаев — так и вышло в первый раз.
 */
export function applyDocumentLang(lang: Lang): void {
  document.documentElement.lang = lang

  /*
    Заодно переписываем заголовок и описание вкладки.

    В `index.html` они по-русски и статичны: страница одна на четыре языка, и
    разложить их там нечем. Поисковик читает именно тот, статический вариант —
    его мы не заменяем, а дополняем: человек с турецким интерфейсом видит
    турецкий заголовок вкладки, и он же уходит в мессенджер, когда этот человек
    делится ссылкой.

    Описание правим у существующего тега, а не добавляем второй: два
    `description` на странице — это неопределённость, которую каждый разберёт
    по-своему.
  */
  const t = makeT(lang)
  document.title = t('docTitle')
  const desc = document.querySelector('meta[name="description"]')
  if (desc) desc.setAttribute('content', t('docDesc'))
}
